import type { ReactElement } from "react";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import type { I18nKeyModifier } from "./types";

type Props = {
    isInnerTableVisible: boolean;
    i18nKeyModifier: I18nKeyModifier;
};

const SaveToListTooltipContent = ({ isInnerTableVisible, i18nKeyModifier }: Props): ReactElement => {
    const tooltipKey = `si.save-to-list.${i18nKeyModifier}.button.tooltip`;

    if (isInnerTableVisible) {
        return <I18n translatable={{ key: `${tooltipKey}.inner-table` }} />;
    }

    return <I18n translatable={{ key: tooltipKey }} />;
};

export default SaveToListTooltipContent;
